import { Component } from "@/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "sansMark"

export const presets = {}

export interface Props extends Component {}

export function SansMark({ children, className, testId = COMPONENT_NAME }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="21"
      fill="none"
      viewBox="0 0 41 21"
      className={cx(``, className)}
      data-test={testId}
    >
      <title>SANS</title>
      <path
        fill="currentColor"
        d="M.833 19.97v-7.117h.554q.122 3.04 1.135 4.888 1.014 1.846 2.5 1.846.77 0 1.257-.543.485-.542.486-1.4 0-.995-.635-2.35-.636-1.355-2.135-3.49Q2.157 9.186 1.596 7.67a9 9 0 0 1-.56-3.137q0-1.994.851-3.208T4.076.111q.662 0 1.29.352.628.351 1.115.977L7.089.137h.554v6.44h-.554q-.23-2.772-1.04-4.344Q5.237.661 4.075.661q-.756 0-1.196.511t-.439 1.393q0 1.253 1.986 3.924.743 1.021 1.149 1.597 1.689 2.44 2.323 4 .636 1.56.636 3.067 0 2.25-.94 3.603-.939 1.355-2.465 1.355a3.4 3.4 0 0 1-1.56-.364q-.71-.364-1.426-1.156l-.757 1.38zM10.994 17.153a5 5 0 0 0-.054.467 8 8 0 0 0-.013.454q0 .626.351.888.352.262 1.204.288v.575H8.276v-.575q1.272-.231 1.731-2.493l.041-.205L13.253.422H15.7l3.462 18.828h.905v.575h-5.476v-.575h1.434l-.825-4.896H11.48zm.566-3.448h3.433l-1.69-9.701z"
      ></path>
      <path
        fill="currentColor"
        d="M19.89 19.817v-.575q.904-.09 1.236-.613.33-.525.33-2.134V.993h-1.323V.418h3.959l5.012 11.732V3.485q0-1.303-.452-1.898-.454-.594-1.466-.594V.418h4.296v.575h-.08q-.853 0-1.163.428-.31.429-.31 1.808v16.588h-.609L22.322 3.754V16.34q0 1.547.486 2.185.487.64 1.702.716v.575zM32.465 19.97v-7.117h.554q.121 3.04 1.135 4.888 1.013 1.846 2.5 1.846.77 0 1.256-.543.487-.542.486-1.4 0-.995-.634-2.35-.636-1.355-2.135-3.49-1.838-2.619-2.399-4.134a9 9 0 0 1-.56-3.137q0-1.994.851-3.208T35.71.111q.66 0 1.29.352.628.351 1.114.977L38.72.137h.554v6.44h-.554q-.23-2.772-1.04-4.344Q36.87.661 35.708.661q-.757 0-1.196.511-.44.511-.439 1.393 0 1.253 1.986 3.924.743 1.021 1.149 1.597 1.688 2.44 2.324 4t.635 3.067q0 2.25-.94 3.603-.94 1.355-2.465 1.355a3.4 3.4 0 0 1-1.561-.364q-.71-.364-1.425-1.156l-.757 1.38z"
      ></path>
      <path fill="currentColor" d="M39.303 14.352H15.267v-.679h24.036z"></path>
    </svg>
  )
}
